// theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      light: "#64b5f6", // lighter sky blue
      main: "#1976d2", // modern MUI default blue
      dark: "#0d47a1", // deep professional blue
      contrastText: "#ffffff",
    },
    secondary: {
      light: "#ffb07c", // warm accent
      main: "#fe8244", // vibrant orange
      dark: "#c65016",
      contrastText: "#ffffff",
    },
    neutral: {
      main: "#64748B", // modern gray (slate)
      contrastText: "#ffffff",
    },
    black: {
      main: "#000000",
      contrastText: "#ffffff",
    },
    background: {
      default: "#f9fafc", // soft background
      paper: "#ffffff",
    },
    text: {
      primary: "#1e293b", // dark slate
      secondary: "#475569", // muted slate
    },
  },

  typography: {
    fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    h1: {
      fontWeight: 700,
      fontSize: "clamp(2.5rem, 5vw, 3rem)",
      lineHeight: 1.2,
    },
    h2: {
      fontWeight: 700,
      fontSize: "clamp(2rem, 4vw, 3rem)",
      lineHeight: 1.3,
    },
    h3: {
      fontWeight: 600,
      fontSize: "clamp(1.75rem, 3.5vw, 2.5rem)",
      lineHeight: 1.3,
    },
    h4: {
      fontWeight: 600,
      fontSize: "clamp(1.5rem, 3vw, 2rem)",
    },
    h5: {
      fontWeight: 500,
      fontSize: "clamp(1.25rem, 2.5vw, 1.75rem)",
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.6,
    },
    body2: {
      fontSize: "0.9rem",
      lineHeight: 1.5,
    },
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "12px",
          textTransform: "none",
          fontWeight: 600,
          padding: "10px 20px",
          boxShadow: "none",
          transition: "all 0.2s ease-in-out",
        },
        containedPrimary: {
          background: "linear-gradient(90deg, #1976d2, #0d47a1)",
          "&:hover": {
            background: "linear-gradient(90deg, #1565c0, #0b3c91)",
          },
        },
        containedSecondary: {
          background: "linear-gradient(90deg, #fe8244, #c65016)",
          "&:hover": {
            background: "linear-gradient(90deg, #e66e2f, #a63d0d)",
          },
        },
        outlinedPrimary: {
          borderColor: "#1976d2",
          color: "#1976d2",
          "&:hover": {
            backgroundColor: "rgba(25, 118, 210, 0.08)",
            borderColor: "#1565c0",
          },
        },
        outlinedSecondary: {
          borderColor: "#fe8244",
          color: "#fe8244",
          "&:hover": {
            backgroundColor: "rgba(254, 130, 68, 0.08)",
            borderColor: "#e66e2f",
          },
        },
      },
    },
  },
});

export default theme;
